/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const ConfirmDataRoutes: Routes = [
  {
    path: RoutePaths.NEW_QUOTATION.CONFIRM_DATA.SUMMARY.route,
    loadChildren: () =>
      import('@pages/confirm-data/project-summary/project-summary.module').then(m => m.ProjectSummaryPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONFIRM_DATA.SAVE_QUOTE.route,
    loadChildren: () => import('@pages/confirm-data/save-quote/save-quote.module').then(m => m.SaveQuotePageModule),
    canActivate: [NavigationGuard],
  },
];
